import React, {Component} from 'react';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import Loading from 'apa/components/Loading';
import BootstrapTable from 'react-bootstrap-table-next';
import NewManualButton from 'customers/manuals/NewManualButton';
import {ButtonGroup} from 'reactstrap';
import DeleteCustomerManual from 'customers/manuals/DeleteCustomerManual';
import autobind from 'autobind-decorator';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Date from 'apa/components/Date';

@connect(
    state => {
        return {
            customers: state.customers,
            auth: state.apa,
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            }
        }
    }
)
export default class ManualList extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            manuals: null,
            customer: null
        };
    }

    componentDidMount() {
        this.fetchManuals();
    }

    @autobind
    fetchManuals() {
        this.setState({
            isLoading: true
        });
        const id = this.props.match.params.id;
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        fetch(
            `/api/customers/${id}/manuals/`
            , {headers})
            .then(res => res.json())
            .then(manuals => {
                this.setState({manuals: manuals});
                fetch(
                    `/api/customers/${id}/`
                    , {headers})
                    .then(res => res.json())
                    .then(customer => this.setState({isLoading: false, customer: customer}))
            });

    }

    render() {
        const columnList = [
            {
                dataField: 'number',
                text: 'Nummer',
            },
            {
                dataField: 'date',
                text: 'Datum',
                formatter: cell => <Date date={cell}/>
            },
            {
                dataField: 'manual_name',
                text: 'Name'
            },
            {
                dataField: 'category_name',
                text: 'Kategorie'
            },
            {
                dataField: 'file',
                text: 'Datei',
                formatter: (cell, row) => <ButtonGroup>
                    <a className='btn btn-primary' href={cell}>
                        <i className='fa fa-download'> </i>
                    </a>
                    <DeleteCustomerManual customer_manual={row} callback={this.fetchManuals}/>
                </ButtonGroup>
            },
        ];
        const id = this.props.match.params.id;
        if (this.state.isLoading)
            return <Loading/>;
        return (
            <DetailContainer id={id}>
                <h1>{this.state.customer.name}</h1>
                <NewManualButton id={id}/>
                <BootstrapTable
                    keyField='id'
                    columns={columnList}
                    data={this.state.manuals}
                    bootstrap4
                    responsive
                    pagination={paginationFactory()}
                />
            </DetailContainer>
        )
    }
}

